import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import {
  getTouchedFromSchema,
  isInvalid,
  touchFieldsFromErrors,
} from "../utils/forms";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import CheckboxField from "./controls/CheckboxField";
import Panel from "./layout/Panel";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import MeasureField from "./controls/MeasureField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";
import { ProductoSchema } from "../data/ProductoSchema";
import "./css/components.css";

export function ProductoElaboradoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  operacionesUnitarias,
  unidadesCantidad,
  disabled,
}) {
  const { t } = useTranslation();
  const initialTouched =
    page >= 0 ? getTouchedFromSchema(value, ProductoSchema) : {};
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnMount={page >= 0}
      initialTouched={initialTouched}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
      validateOnChange={true}
      validationSchema={ProductoSchema}
    >
      {(productoElaboradoForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("productoElaboradoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextField
                id="producto_nombre"
                name="nombre"
                label={t("producto.nombre")}
                value={productoElaboradoForm.values.nombre}
                onChange={(event) => productoElaboradoForm.handleChange(event)}
                isInvalid={isInvalid("nombre", productoElaboradoForm)}
                error={t(productoElaboradoForm.errors.nombre)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <CheckboxField
                id="producto_operacionesUnitarias"
                name="operacionesUnitarias"
                label={t("producto.operacionesUnitarias")}
                value={productoElaboradoForm.values.operacionesUnitarias}
                onChange={(event) => productoElaboradoForm.handleChange(event)}
                options={operacionesUnitarias}
                lg={6}
                labelAttr="nombre"
                valueAttr="orden"
                isInvalid={isInvalid(
                  "operacionesUnitarias",
                  productoElaboradoForm,
                )}
                error={t(productoElaboradoForm.errors.operacionesUnitarias)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <MeasureField
                id="producto_cantidad"
                name="cantidad"
                label={t("producto.cantidad")}
                value={productoElaboradoForm.values.cantidad}
                onChange={(event) => productoElaboradoForm.handleChange(event)}
                units={unidadesCantidad}
                isInvalid={isInvalid("cantidad", productoElaboradoForm)}
                error={t(productoElaboradoForm.errors.cantidad)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={7}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={5}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("productoElaboradoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("productoElaboradoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("productoElaboradoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    productoElaboradoForm.validateForm().then((errors) => {
                      if (
                        touchFieldsFromErrors(errors, productoElaboradoForm)
                      ) {
                        return;
                      }
                      productoElaboradoForm.submitForm();
                    });
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("productoElaboradoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
